// extracted by mini-css-extract-plugin
export default {"separatorAdditionalText":"v90plyfNwZqolLIfUhEr"};